module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/interview-89c44a4e197b1bd70b5ea4826ff43706.svg";